import Page from './acesse-condominio'
export default Page
